import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-dialog-change',
  templateUrl: './confirm-dialog-change.component.html',
  styleUrls: ['./confirm-dialog-change.component.scss']
})
export class ConfirmDialogChangeComponent implements OnInit {
  title: string;
  message: string;
  confirm: string;
  showFinish:boolean=false;

  constructor(public dialogRef: MatDialogRef<ConfirmDialogChangeComponent>, @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogModel) {
    // Update view with given values
    this.title = data.title;
    this.message = data.message;
    this.confirm = data.confirm;

    if(this.message=="You’ve reached the end of the document. Select an option below to Finish or go back to the beginning."){
      this.showFinish=true;
    }else{
      this.showFinish=false
    }
  }

  ngOnInit(): void {
  }

  onConfirm() {
    // Close the dialog, return true
    this.dialogRef.close(true);
  }

  onDismiss(): void {
    // Close the dialog, return false
    this.dialogRef.close(false);
  }

  onFinish(): void {
    // Close the dialog, return false
    this.dialogRef.close("Finish");
  }  

  WithoutFolder(): void {   
    this.dialogRef.close("WithoutFolder");
  }  
   CreateNewFolder(): void {   
    this.dialogRef.close("CreateNewFolder");
  }  
  

}

/**
 * Class to represent confirm dialog model.
 *
 * It has been kept here to keep it as part of shared component.
 */
export class ConfirmDialogModel {

  constructor(public title: string, public message: string, public confirm:string) {
  }
}
